import { findSegmentIndex } from '@/utils/helpers/train-simulation/find-segment-index';

export const interpolatePosition = (
  targetDistance: number,
  path: [number, number][],
  distances: Float64Array | null,
  outputCoords: number[]
): number => {
  if (!distances || distances.length < 2 || path.length < 2) {
    outputCoords[0] = path[0][0];
    outputCoords[1] = path[0][1];

    return 0;
  }

  const i = findSegmentIndex(targetDistance, distances);

  const startDist = distances[i];
  const endDist = distances[i + 1];
  const segmentLength = endDist - startDist;
  const ratio = segmentLength > 0.001 ? (targetDistance - startDist) / segmentLength : 0;

  const p1 = path[i];
  const p2 = path[i + 1];

  outputCoords[0] = p1[0] + (p2[0] - p1[0]) * ratio;
  outputCoords[1] = p1[1] + (p2[1] - p1[1]) * ratio;

  return i;
};
